import { mapToCamelCase } from '@consigli/utils';
import { z } from 'zod';
import { getPaginationResponseSchema } from './pagination';
import { ProjectRole } from './project-properties';
import { ServicePermissionName } from './service';
export const projectAccessSchema = z
    .object({
    id: z.number().int(),
    name: z.string(),
    role: z.nativeEnum(ProjectRole),
    services: z.array(z.nativeEnum(ServicePermissionName)),
})
    .strict()
    .transform(mapToCamelCase);
export const userSchema = z
    .object({
    id: z.string().uuid(),
    first_name: z.string(),
    last_name: z.string(),
    email: z.string(),
    is_superuser: z.boolean(),
    organization_id: z.string().uuid().nullable(),
    organization_name: z.string().nullable(),
    is_org_admin: z.boolean(),
    project_access: z.array(projectAccessSchema),
    terms_and_conditions_accepted: z.boolean(),
    terms_and_conditions_accepted_at: z.string().datetime().nullable(),
    data_processing_accepted: z.boolean(),
    data_processing_accepted_at: z.string().datetime().nullable(),
    sso_country: z.string().nullable(),
    sso_business_line: z.string().nullable(),
    solution_viewer_access: z.boolean(),
    solution_viewer_datacenter_access: z.boolean(),
    solution_viewer_water_treatment_access: z.boolean(),
    debug_mode_access: z.boolean(),
    // Null until the user first logs in.
    last_login: z.string().datetime({ offset: true }).nullable(),
    aecom_employee_id: z.string().nullable(),
})
    .strict()
    .transform(mapToCamelCase);
export const getUserRequestSchema = z
    .object({
    id: z.string().uuid(),
})
    .strict()
    .transform(mapToCamelCase);
export const getUserResponseSchema = userSchema;
export const getUsersResponseSchema = getPaginationResponseSchema(userSchema);
export const getUsersRequestSchema = z
    .object({
    page: z.union([z.number().int(), z.literal('all')]),
    page_size: z.number().int().nullish(),
    search: z.string().nullish(),
    org_ids: z.array(z.string().uuid()).nullish(),
    project_ids: z.array(z.number().int()).nullish(),
})
    .strict()
    .transform(mapToCamelCase);
export const getUserCountResponseSchema = z
    .object({
    count: z.number().int(),
})
    .strict()
    .transform(mapToCamelCase);
